import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CaseStudy from "@/pages/CaseStudy";
import { Loader } from "@/components/Loader";

function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App bg-cream min-h-screen">
        <div className="grain" />
        <Loader onDone={() => setLoaded(true)} />
        <Toaster position="bottom-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/case-study/:id" element={<CaseStudy />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
